var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSellFab = function SvgSellFab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 158 161"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#sell-fab_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "sell-fab_svg__root-shadow",
    filter: "url(#sell-fab_svg__b)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    fillRule: "evenodd",
    d: "M130.037 96.531 137 112.806v1.455c0 10.235-8.19 18.532-18.293 18.532H40.293C30.19 132.793 22 124.496 22 114.261v-1.455l6.963-16.275c.666-7.558 5.81-13.81 12.726-16.013a39.98 39.98 0 0 1-1.823-11.97c0-21.835 17.472-39.535 39.024-39.535 21.553 0 39.025 17.7 39.025 39.535 0 4.053-.604 7.967-1.725 11.652 7.475 1.858 13.145 8.37 13.847 16.331Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0073",
    fillRule: "evenodd",
    d: "M105.039 79.5a34.918 34.918 0 0 0 8.12-22.439C113.159 37.697 97.461 22 78.098 22c-19.364 0-35.061 15.697-35.061 35.061 0 8.536 3.05 16.359 8.12 22.439H38.415a8 8 0 0 0-8 8v14.854a8 8 0 0 0 8 8h80.768a8 8 0 0 0 8-8V87.5a8 8 0 0 0-8-8h-14.144Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sell-fab_svg__c",
    width: 118,
    height: 109,
    x: 20,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M137.415 12h-117v109h117V12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M105.039 79.5a34.918 34.918 0 0 0 8.12-22.439C113.159 37.697 97.461 22 78.098 22c-19.364 0-35.061 15.697-35.061 35.061 0 8.536 3.05 16.359 8.12 22.439H38.415a8 8 0 0 0-8 8v14.854a8 8 0 0 0 8 8h80.768a8 8 0 0 0 8-8V87.5a8 8 0 0 0-8-8h-14.144Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sell-fab_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m104.624 79.5-7.68-6.404L83.266 89.5h21.358v-10Zm-53.882 0v10H72.1L58.422 73.096l-7.68 6.404Zm52.002-22.439c0 6.11-2.174 11.685-5.8 16.035l15.36 12.808a44.918 44.918 0 0 0 10.44-28.843h-20ZM77.683 32c13.84 0 25.061 11.22 25.061 25.061h20C122.744 32.175 102.569 12 77.683 12v20ZM52.622 57.061c0-13.84 11.22-25.061 25.06-25.061V12c-24.886 0-45.06 20.175-45.06 45.061h20Zm5.8 16.035a24.92 24.92 0 0 1-5.8-16.035h-20a44.92 44.92 0 0 0 10.44 28.843l15.36-12.808ZM38 89.5h12.742v-20H38v20Zm2-2a2 2 0 0 1-2 2v-20c-9.941 0-18 8.059-18 18h20Zm0 14.854V87.5H20v14.854h20Zm-2-2a2 2 0 0 1 2 2H20c0 9.941 8.059 18 18 18v-20Zm80.768 0H38v20h80.768v-20Zm-2 2a2 2 0 0 1 2-2v20c9.941 0 18-8.059 18-18h-20Zm0-14.854v14.854h20V87.5h-20Zm2 2a2 2 0 0 1-2-2h20c0-9.941-8.059-18-18-18v20Zm-14.144 0h14.144v-20h-14.144v20Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sell-fab_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.156 65.566a4.884 4.884 0 0 1-4.883 4.875H66.558c-5.512-.013-6.703-7.817-1.513-9.486 6.31 8.845 20.434 8.842 26.742 0 1.949.64 3.369 2.454 3.369 4.61Zm-2.79-14.627c0 7.681-6.258 13.93-13.95 13.93-18.481-.7-18.476-27.161 0-27.86 7.692 0 13.95 6.25 13.95 13.93Zm-8.37 2.786a3.85 3.85 0 0 0-3.23-3.807l-4.242-.704c-1.516-.294-.894-2.544.497-2.453h3.164a1.4 1.4 0 0 1 1.21.697 1.393 1.393 0 0 0 1.905.507 1.39 1.39 0 0 0 .509-1.902 4.2 4.2 0 0 0-3.624-2.088h-.374v-1.393c-.009-1.822-2.783-1.821-2.79 0v1.393c-4.792-.027-5.837 7.08-.956 7.985l4.242.705c1.517.294.895 2.544-.496 2.453h-3.164a1.4 1.4 0 0 1-1.21-.698 1.393 1.393 0 0 0-1.905-.507 1.39 1.39 0 0 0-.51 1.903 4.2 4.2 0 0 0 3.625 2.088h.374v1.393c.008 1.822 2.783 1.82 2.79 0v-1.393a4.187 4.187 0 0 0 4.185-4.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0073",
    d: "M119.183 79.5H38.415a8 8 0 0 0-8 8v14.854a8 8 0 0 0 8 8h80.768a8 8 0 0 0 8-8V87.5a8 8 0 0 0-8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.487 101.053c-.924 0-1.752-.15-2.484-.45-.732-.3-1.32-.744-1.764-1.332-.432-.588-.66-1.296-.684-2.124h3.276c.048.468.21.828.486 1.08.276.24.636.36 1.08.36.456 0 .816-.102 1.08-.306.264-.216.396-.51.396-.882 0-.312-.108-.57-.324-.774a2.403 2.403 0 0 0-.774-.504c-.3-.132-.732-.282-1.296-.45-.816-.252-1.482-.504-1.998-.756a3.692 3.692 0 0 1-1.332-1.116c-.372-.492-.558-1.134-.558-1.926 0-1.176.426-2.094 1.278-2.754.852-.672 1.962-1.008 3.33-1.008 1.392 0 2.514.336 3.366 1.008.852.66 1.308 1.584 1.368 2.772h-3.33c-.024-.408-.174-.726-.45-.954-.276-.24-.63-.36-1.062-.36-.372 0-.672.102-.9.306-.228.192-.342.474-.342.846 0 .408.192.726.576.954.384.228.984.474 1.8.738.816.276 1.476.54 1.98.792.516.252.96.618 1.332 1.098.372.48.558 1.098.558 1.854 0 .72-.186 1.374-.558 1.962-.36.588-.888 1.056-1.584 1.404-.696.348-1.518.522-2.466.522Zm9.58-10.296v2.556h4.122v2.376h-4.122v2.772h4.662v2.466h-7.74V88.291h7.74v2.466h-4.662Zm9.739 7.794h4.032v2.376h-7.11V88.291h3.078v10.26Zm8.578 0h4.032v2.376h-7.11V88.291h3.078v10.26Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sell-fab_svg__a",
    width: 164.585,
    height: 168.793,
    x: -3.585,
    y: -4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.106028 0 0 0 0 0.18106 0 0 0 0 0.366667 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8_177",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sell-fab_svg__b",
    width: 129,
    height: 117.78,
    x: 15,
    y: 22.013,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8_177",
    stdDeviation: 3.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sell-fab_svg__d",
    width: 120.768,
    height: 97.344,
    x: 18.415,
    y: 27.01,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8_177",
    result: "shape"
  })))));
};
export default SvgSellFab;